(async () => {
    const { Core } = await importModule('Core');
    const { $show } = await importModule('Utils');

    const CN_EXPANDED = '!expanded';
    const EXPAND_THRESHOLD = 100;
    
    customElements.define('product-description-expand', class extends Core {
        elements = {
            content: '[data-content]',
            link: '[data-expand-link]'
        }


        render() {
            const contentHeight = this.$content.offsetHeight;
            if(contentHeight > EXPAND_THRESHOLD * 1.25) {
                this.classList.remove(CN_EXPANDED);
                this.style.setProperty('--expand-height', `${EXPAND_THRESHOLD}px`);
                $show(this.$link);
                this.$link.addEventListener('click', () => {
                    this.classList.toggle(CN_EXPANDED);
                })
            }
        }
    })
})();
document.addEventListener("DOMContentLoaded", function () {
  const expandWrapper = document.querySelector('.#product-description-expand');
  const expandBtn = document.querySelector('button[data-expand-link]');

  if (expandWrapper && expandBtn) {
    expandBtn.addEventListener('click', function (e) {
      e.preventDefault();

      // Get current scroll position before expanding
      const currentScroll = window.pageYOffset;

      // Add 'expanded' class to show full content
      expandWrapper.classList.add('expanded');

      // Restore the scroll position after content is expanded
      setTimeout(() => {
        window.scrollTo({
          top: currentScroll,
          behavior: 'auto'
        });
      }, 10); // short delay to let content expand
    });
  }
});
